import { addDays, format, isSameMonth, isSameYear, startOfWeek } from "date-fns"
import type { CalendarView } from "@/js/types/calendar"

export const getViewTitle = (view: CalendarView, date: Date): string => {
	if (view === "month") return format(date, "MMMM yyyy")
	if (view === "day") return format(date, "EEEE, MMMM d, yyyy")

	const start = startOfWeek(date)
	const end = addDays(start, 6)
	if (!isSameYear(start, end)) return `${format(start, "MMM d, yyyy")} – ${format(end, "MMM d, yyyy")}`
	if (!isSameMonth(start, end)) return `${format(start, "MMM d")} – ${format(end, "MMM d, yyyy")}`
	return `${format(start, "MMM d")} – ${format(end, "d, yyyy")}`
}
